module.exports = __webpack_public_path__ + "static/media/tf.fd20c9ec.svg";